import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SiumpAnalise } from '../models/siump-analise.model';
import { FgtsSiumpRepository } from '../repositories/fgts-siump.repository';

@Injectable({ providedIn: 'root' })
export class FgtsSiumpService implements FgtsSiumpRepository {
  private readonly http = inject(HttpClient);
  private readonly endpoint = `${environment.FI_FINANC_IMOB_BE}fgts/siump`;

  analisarArquivo(arquivo: File): Observable<SiumpAnalise> {
    const body = new FormData();
    body.append('file', arquivo, arquivo.name);
    return this.http.post<SiumpAnalise>(`${this.endpoint}/analyses`, body);
  }
}
